// Shared lightweight-charts look for the ops pages (/ops/charts and the trade detail chart).

export const chartTheme = (dark) => ({
  layout: {
    background: { color: dark ? "hsl(225, 30%, 6%)" : "hsl(0, 0%, 100%)" },
    textColor: dark ? "hsl(220, 10%, 70%)" : "hsl(220, 9%, 35%)",
    fontSize: 11,
    fontFamily: "Inter, ui-sans-serif, system-ui, -apple-system, 'Segoe UI', sans-serif",
    panes: { separatorColor: dark ? "hsl(225, 18%, 18%)" : "hsl(220, 13%, 86%)", separatorHoverColor: "hsla(178, 84%, 40%, 0.25)" },
  },
  localization: {
    locale: "en-US",
    dateFormat: "yyyy-MM-dd",
    timeFormatter: (time) => {
      const d = new Date(time * 1000);
      const h = d.getUTCHours().toString().padStart(2, "0");
      const m = d.getUTCMinutes().toString().padStart(2, "0");
      return `${h}:${m}`;
    },
  },
  grid: {
    vertLines: { color: dark ? "hsl(225, 18%, 12%)" : "hsl(220, 13%, 93%)" },
    horzLines: { color: dark ? "hsl(225, 18%, 12%)" : "hsl(220, 13%, 93%)" },
  },
  crosshair: {
    mode: 0,
    vertLine: { color: "hsl(178, 84%, 40%)", width: 1, style: 2, labelBackgroundColor: dark ? "hsl(225, 24%, 10%)" : "hsl(178, 84%, 30%)" },
    horzLine: { color: "hsl(178, 84%, 40%)", width: 1, style: 2, labelBackgroundColor: dark ? "hsl(225, 24%, 10%)" : "hsl(178, 84%, 30%)" },
  },
  timeScale: { borderColor: dark ? "hsl(225, 18%, 18%)" : "hsl(220, 13%, 86%)", timeVisible: true, secondsVisible: false },
  rightPriceScale: { borderColor: dark ? "hsl(225, 18%, 18%)" : "hsl(220, 13%, 86%)", scaleMargins: { top: 0.08, bottom: 0.22 } },
});

export const CANDLE_COLORS = {
  upColor: "#22c55e",
  downColor: "#ef4444",
  borderDownColor: "#dc2626",
  borderUpColor: "#16a34a",
  wickDownColor: "#dc2626",
  wickUpColor: "#16a34a",
};
